import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getIsContentFullWidthLayout({ content }: Props) {
  return content.layout === 'FULL_WIDTH' && !content.sidebar;
}
